"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const el = document.querySelector(
            '.o-marcas__logos[data-swiper="marcas"]',
        );
        if (!el) return;

        const wrap = el.closest(".o-marcas__slider");
        const btnPrev = wrap?.querySelector(".o-marcas__arrow--prev");
        const btnNext = wrap?.querySelector(".o-marcas__arrow--next");

        const isDesktop = () =>
            window.matchMedia("(min-width: 1024px)").matches;

        const swiper = new Swiper(el, {
            modules: [Navigation],
            slidesPerView: 3,
            spaceBetween: 16,
            loop: true,
            navigation: {
                prevEl: btnPrev,
                nextEl: btnNext,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 7,
                    spaceBetween: 84,
                },
            },
            on: {
                init(s) {
                    if (!isDesktop()) {
                        s.navigation.disable();
                    }
                },
                resize(s) {
                    if (isDesktop()) {
                        s.navigation.enable();
                    } else {
                        s.navigation.disable();
                    }
                },
            },
        });
    });
}
